import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g color="#000" fontWeight={400} fontFamily="sans-serif" fill="#2e3436"><path d="M10 4v6.5h2V4zM4 4v8h2V4zm3.985.986A1 1 0 007 6v4.563a1 1 0 102 0V6a1 1 0 00-1.015-1.014z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} overflow="visible" /><path d="M7 10.5a2.502 2.502 0 003.75 2.164A2.502 2.502 0 0012 10.5h-2c0 .18-.094.344-.25.434a.496.496 0 01-.5 0A.497.497 0 019 10.5zM4 4c0-1.427.764-2.75 2-3.465a4.004 4.004 0 014 0c1.236.714 2 2.038 2 3.465h-2c0-.716-.38-1.374-1-1.732a1.996 1.996 0 00-2 0C6.38 2.626 6 3.284 6 4zm0 8a4 4 0 004 4v-2a1.998 1.998 0 01-2-2z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1
      }} overflow="visible" /><path d="M8 14a1 1 0 100 2h2a1 1 0 100-2z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} overflow="visible" /></g></svg>;
}

export default SvgComponent;